export const MAX_AMOUNT = 4000;
